import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

import 'flag-icon-css/css/flag-icon.min.css'

// axios
import axios from "./axios.js"
Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'


// ACL
//import acl from '@/configs/acl.config.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// VeeValidate
import th from 'vee-validate/dist/locale/th';
import VeeValidate, { Validator } from 'vee-validate';
Vue.use(VeeValidate);
Validator.localize('th', th);

Vue.config.productionTip = false

import firebase from 'firebase/app'
import 'firebase/auth'
const configOptions = {
  apiKey: "AIzaSyAzaBiQCy1_ucChSRNb5r4AQCayzJH873o",
  authDomain: "lotto-388408.firebaseapp.com",
  projectId: "lotto-388408",
  storageBucket: "lotto-388408.appspot.com",
  messagingSenderId: "472810097539",
  appId: "1:472810097539:web:37440d4c766dc6818784b6",
  measurementId: "G-LKFLHZF5BP"
};
firebase.initializeApp(configOptions)

new Vue({
  router,
  store,
  //acl,
  render: h => h(App)
}).$mount('#app')
